/* eslint-disable no-unused-vars */
import getEnvironmentalVariables from './getEnvironmentalVariables';

export const { BASE_URL } = getEnvironmentalVariables();

export const ORGANIZATION_USER_FEATURE_ACCESS_QUERY_KEY = 'OrganizationUserFeatureAccess' as const;

export const FEATURE_IDS = {
    DEAL_PIPELINE: 141,
    REPORTING_ACROSS_DEALS: 142,
    DEAL_INCOMING_APPROVALS: 143,
    BACK_OF_ENVELOPE: 144,
    DEAL_DASHBOARD: 145,
    DEAL_DOCUMENTS: 148,
    DEAL_REPORT_BUILDER: 149,
    PRO_FORMA: 150,
    DEAL_ORGANIZATION_MANAGEMENT: 151,
    CRM_CONTACTS: 152,
    CRM_COMPANIES: 153,
};

export enum FEATURES_LIST {
    DEAL_DOCUMENTS ='deal_documents',
    PORTFOLIO_INVOICE_DATA_INDEX = 'portfolio_invoice_data_index',
    PORTFOLIO_VENDOR_ANALYTICS = 'portfolio_vendor_analytics',
    QUICK_ANALYTICS = 'quick_analytics',
    PORTFOLIO_BUDGET_CATEGORIZATIONS = 'portfolio_budget_categorizations',
    PORTFOLIO_CAPITAL_PLANNING = 'portfolio_capital_planning',
    GLOBAL_COST_FORECAST = 'global_cost_forecast',
    GLOBAL_COST_FORECAST_V2 = 'global_cost_forecast_v2',
    PORTFOLIO_DEVELOPER_FEE = 'portfolio_developer_fee',
    PORTFOLIO_COST_ANALYTICS = 'portfolio_cost_analytics',
    VENDOR_DIRECTORY = 'vendor_directory',
    DATA_INBOX_APPROVAL_WORKFLOW = 'data_inbox_approval_workflow',
}

export const USER_CLASSES = {
    SUPER_ADMIN: 6,
    CUSTOM: 12,
};

export const SELECTED_ORGANIZATION_ID = 'selected_organization_id' as const;
